module.exports = __webpack_public_path__ + "img/step3-3.74e9d1f2.png";